module.exports = __webpack_public_path__ + "img/icon.8bfa51a5.png";